import { getDockedStyles } from '../dockedLayer'
import type { PopupAlignment } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import type { DockedCompLayout } from '../types'

const convertPopupAlignmentToDockedData = (popupAlignment: PopupAlignment) => {
	const horizontalAlignmentToDockKey = {
		left: 'left',
		right: 'right',
		center: 'hCenter',
	}
	const verticalAlignmentToDockKey = {
		top: 'top',
		bottom: 'bottom',
		center: 'vCenter',
	}

	if (popupAlignment.alignmentType === 'nineGrid') {
		return {
			[horizontalAlignmentToDockKey[popupAlignment.horizontalAlignment]]: { px: popupAlignment.horizontalOffset },
			[verticalAlignmentToDockKey[popupAlignment.verticalAlignment]]: { px: popupAlignment.verticalOffset },
		}
	}

	if (popupAlignment.alignmentType === 'fullHeight') {
		return {
			top: { px: 0 },
			bottom: { px: 0 },
			[horizontalAlignmentToDockKey[popupAlignment.horizontalAlignment]]: { px: 0 },
		}
	}

	if (popupAlignment.alignmentType === 'fullWidth') {
		return {
			left: { px: 0 },
			right: { px: 0 },
			[verticalAlignmentToDockKey[popupAlignment.verticalAlignment]]: { px: 0 },
		}
	}
	return {}
}

const getDockedCssForCompLayouts = (compLayout: DockedCompLayout, popupAlignment: PopupAlignment) => {
	const isIE = false // TODO: Real isIE
	const growToContent = true
	const dockedPopup = _.defaults({ docked: convertPopupAlignmentToDockedData(popupAlignment) }, compLayout)
	const dockedStyles = getDockedStyles([dockedPopup], isIE, growToContent)
	return _.mapKeys(dockedStyles[compLayout.id], (val, key) => _.kebabCase(key))
}

export { getDockedCssForCompLayouts }
